
import { mapState, mapActions } from 'vuex';
import Icon from '../../common/Icon'
import Button from '../Button.vue'
import OrderCard from '../../common/OrderCard.vue'

export default {
  name: 'OrderAgain',
  components: { 
    Icon,
    Button,
    OrderCard,
  },
  props: {
    blok: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: true,
    }
  },
  mounted() {
    if (this.blok && this.blok.show === 'user' && !this.user) {
      this.show = false
    }
  },
  computed: { 
    ...mapState(['orderHistory', 'user']),
  },
  methods: {
    ...mapActions([ 'getOrderHistory' ]),
  },
  async beforeMount() {
    await this.getOrderHistory()
  },
}
